import api from 'service/api'

const marketPlaceAPI = api.create('marketPlace', false)

const get = async ({ ...params }) => {
  return await marketPlaceAPI.get('/showcases/company_services', { params })
}

const serviceCompanies = {
  get,
}

export default serviceCompanies
